<template>
  <s-filter :active="!!model.length" :label="label" :active-label="activeLabel" @clear="model = []">
    <template #value>
      <slot name="label" :options="selectedOptions">
        <span class="comma-separated">
          <span v-for="option in selectedOptions" :key="option.value">
            {{ option.label }}
          </span>
        </span>
      </slot>
    </template>
    <template #default="{close}">
      <s-multi-select-filter-content
        :options
        v-model="model"
        value-key="value"
        label-key="label"
        @close="close"
      >
        <template #option="{option}">
          <slot name="option" :option="option">
            {{ option.label }}
          </slot>
        </template>
      </s-multi-select-filter-content>
    </template>
  </s-filter>
</template>
<script setup lang="ts">
import SMultiSelectFilterContent from '../SMultiSelectFilterContent.vue';
import SFilter from '../SFilter.vue';
import {computed} from 'vue';

type Option = {
  value: string | number;
  label: string;
};

const {options} = defineProps<{
  label: string;
  activeLabel?: string;
  options: Option[];
}>();

const model = defineModel<(number | string)[]>({default: []});

const selectedOptions = computed(() => {
  return options.filter((option) => model.value.includes(option.value));
});
</script>
